import axios from 'axios';
import config from '../config';

const passwordReset = async data => {
  const res = await axios.post(`${config.API_URL}/api/accounts/password-reset/`, data);
  return res;
};

export default passwordReset;
